<template>
  <div class="urlParse app-container">
    <div class="global-header-wrap">
      <h3>网页解析规则</h3>
      <div class="urlParse-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'urlParseCreate' })"
        >
          新增
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <!-- <div slot="header">
        <div class="global-table-header">
          <div class="urlParse-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <el-dialog
      title="规则详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="tagItem">
        <div class="urlParse-dialog-item">
          <p>标题</p>
          <p>{{ tagItem.name }}</p>
        </div>
        <div class="urlParse-dialog-item">
          <p>HOST</p>
          <p>{{ tagItem.host }}</p>
        </div>
        <div class="urlParse-dialog-item">
          <p>版本</p>
          <p>{{ tagItem.version }}</p>
        </div>
        <div class="urlParse-dialog-item">
          <p>JS</p>
          <p v-for="(js, index) in tagItem.js" :key="index">
            {{ js.displayName }}
          </p>
        </div>
        <div class="urlParse-dialog-item">
          <p>CSS</p>
          <p v-for="(css, index) in tagItem.css" :key="index">
            {{ css.displayName }}
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  computed: {
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
        // models: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("devices.power.title")
        },
        {
          prop: "host",
          label: "HOST"
        },
        {
          prop: "version",
          label: "版本"
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 220,
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: "",
        models: ""
      },
      params: {
        limit: 20,
        page: 1
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false
    };
  },
  methods: {
    getList() {
      this.$http.getUrlParseInfo(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    del(data) {
      this.$http.delUrlParseInfo(data.row._id).then(res => {
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.tableData.splice(data.$index, 1);
      });
    },

    toDetails(data) {
      this.tagItem = data.row;
      this.centerDialogVisible = true;
    },

    edit(data) {
      this.$router.push({
        name: "urlParseCreate",
        query: { id: data.row._id }
      });
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val;
      } else {
        delete this.params.name;
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.urlParse {
  .urlParse-btn {
    text-align: right;
    padding: 10px;
  }
  .urlParse-pagination {
    padding: 10px;
    text-align: right;
  }
  .urlParse-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
}
</style>
